import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const InternetErrorSection = ({ routeData }) => {
  return (
    <div className="internet-error-container">
      <div className="question-container">
        <img alt="" src={require("@/assets/images/500-question.svg")} />
        <div className="title">
          アクセスしようとしたページは表示できませんでした
        </div>
        <div className="description">
          現在、サーバーへのアクセスが集中し、ページを閲覧しにくい状態になっております。
          <br />
          ご迷惑をおかけいたしますが、時間を置いて再度アクセスいただきますようお願いいたします。
        </div>
      </div>
      <Placeholder
        name="jss-contact"
        rendering={routeData}
        routeData={routeData}
      />
    </div>
  );
};

export default InternetErrorSection;
